import Activity from 'ef/models/activity';
import ActivityProgress from 'ef/models/activity_progress';
import Answer from 'ef/models/answer';
import ArrayStorageWrapper from 'ef/models/array_storage_wrapper';
import Assessment from 'ef/models/assessment';
import ContentPage from 'ef/models/content_page';
import Customization from 'ef/models/customization';
import { Enrollment } from 'ef/models/enrollment';
import Group from 'ef/models/group';
import Location from 'ef/models/location';
import Module from 'ef/models/module';
import Page from 'ef/models/page';
import Poll from 'ef/models/poll';
import PollResults from 'ef/models/poll_results';
import Program from 'ef/models/program';
import ProgressQueue from 'ef/models/progress_queue';
import ProgressTracker from 'ef/models/progress_tracker';
import Question from 'ef/models/question';
import Resource from 'ef/models/resource';
import Response from 'ef/models/response';
import ResponseSet from 'ef/models/response_set';
import Section from 'ef/models/section';

import AssessmentsAnswer from 'ef/models/assessments/answer';
import AssessmentsAssessment from 'ef/models/assessments/assessment';
import AssessmentsAttempt from 'ef/models/assessments/attempt';
import AssessmentsQuestion from 'ef/models/assessments/question';
import EvaluationsResponseSet from 'ef/models/evaluations/response_set';

export default {
  Activity,
  ActivityProgress,
  Answer,
  ArrayStorageWrapper,
  Assessment,
  ContentPage,
  Customization,
  Enrollment,
  Group,
  Location,
  Module,
  Page,
  Poll,
  PollResults,
  Program,
  ProgressQueue,
  ProgressTracker,
  Question,
  Resource,
  Response,
  ResponseSet,
  Section,
  Assessments: {
    Answer: AssessmentsAnswer,
    Assessment: AssessmentsAssessment,
    Attempt: AssessmentsAttempt,
    Question: AssessmentsQuestion,
  },
  Evaluations: { ResponseSet: EvaluationsResponseSet },
};
